export enum UnitType {
    kg = 'kg',
    piece = 'piece(s)',
}
